import React from 'react';
import Markdown from 'react-markdown';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { useGlobalData } from '../../../providers/globalDataProvider/globalDataProvider.useGlobalData';

const TermsAndConditions = ({ textKey }) => {
  const { t } = useTranslation();
  const { country, language } = useGlobalData();
  const key = `${textKey}.${country}.${language}`;
  let text = t(key);
  text = text.length && text !== key ? text : t(textKey);
  return <Markdown>{text}</Markdown>;
};

export default TermsAndConditions;
